define('modules/common/directive/DocumentFolderNavigation',[], function () {
    var Directive = function ($location, $state) {

        return {
            restrict: 'E',
            scope: {
                cartellacorrente: '=',
                cartellapadre: '='
            },
            replace: true,
            templateUrl: 'modules/common/view/documentFolderNavigation.tpl.html',
            controller: ["$scope", function ($scope) {

                if ($scope.cartellapadre) {
                    console.log($scope.cartellapadre);
                }

                $scope.openFolder = function (idCartella, $event) {
                    $event.preventDefault();
                    $location.search('idCartella', idCartella);
                    return false;
                }

            }],
            link: ["$scope", "element", "attrs", function ($scope, element, attrs) { }]
        };

    };
    return ["$location","$state", Directive];
});
